module.exports = __webpack_public_path__ + "img/상단 텍스트_아이콘_small.9925b45c.svg";